import type { DotNetObjectReference, IResizeModule } from '../types';

/**
 * Modul für Window-Resize-Events mit Debouncing
 * Ermöglicht .NET-Komponenten, auf Fenstergrößenänderungen zu reagieren
 */
const ResizeModule: IResizeModule & { resizeTimer: ReturnType<typeof setTimeout> | null } = {
    resizeTimer: null,
    debounceDelay: 150, // Millisekunden
    
    /**
     * Registriert einen Window-Resize-Listener mit .NET-Callback
     * @param dotNetObj - .NET-Objektreferenz für Callbacks
     */
    registerWindowResize(dotNetObj: DotNetObjectReference): void {
        window.addEventListener('resize', () => {
            // Vorherigen Timer löschen
            if (this.resizeTimer !== null) {
                clearTimeout(this.resizeTimer);
            }
            
            // Neuen Timer setzen
            this.resizeTimer = setTimeout(() => {
                dotNetObj.invokeMethodAsync<void>(
                    'OnWindowResize', 
                    window.innerWidth.toString(), 
                    window.innerHeight.toString()
                );
            }, this.debounceDelay);
        });
    },

    /**
     * Gibt die aktuellen Fenster-Dimensionen zurück
     * @returns String im Format "width;height"
     */
    getWindowDimensions(): string {
        return `${window.innerWidth};${window.innerHeight}`;
    }
};

export default ResizeModule;
